<ng-container *ngIf="paymentResponseMessageType">
  <div class="page-title">Detalhes da resposta</div>
  <div class="details payment-response-details">
    <div class="details__left">
      <div class="card card-user">
        <div class="image"></div>
        <div class="card-body">
          <div class="user">
            <img
              class="avatar"
              [src]="paymentResponseMessageType.iconURL"
              *ngIf="paymentResponseMessageType.iconURL"
            />
            <h4>{{ paymentResponseMessageType.typeContent }}</h4>
            <p *ngIf="paymentResponseMessageType.typeContent">
              <b> Título </b>:
              {{ paymentResponseMessageType.typeContent }}
            </p>
            <p *ngIf="paymentResponseMessageType.messageContent">
              <b>Conteúdo</b>:
              {{ paymentResponseMessageType.messageContent }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="details__right">
      <div class="card">
        <p-tabView
          *ngIf="selectedTab !== undefined"
          [activeIndex]="selectedTab"
          (activeIndexChange)="goToResponseMessageType($event)"
        >
          <p-tabPanel header="Informações gerais">
            <ng-template pTemplate="content">
              <app-payment-response-message-type-form
                [paymentResponseMessageType]="paymentResponseMessageType"
                (updated)="paymentResponseMessageType = $event"
                [permission]="permission"
              />
            </ng-template>
          </p-tabPanel>
          <p-tabPanel
            header="Códigos de erro {{
              totalErrorCodes !== undefined
                ? '(' + (totalErrorCodes | number: '1.0-0') + ')'
                : ''
            }}"
          >
            <ng-template pTemplate="content">
              <app-table
                #codesTable
                *ngIf="cols && dropdownFilters"
                [cols]="cols"
                [findPage]="findPage"
                [service]="financialService"
                modelName="erros"
                sortField="paymentResponseMessageId"
                addLabel="Novo erro"
                [addButton]="false"
                [dropdownFilters]="dropdownFilters"
                tableTitle="Códigos de erro de cobrança"
                [multiSelectFilter]="true"
                [fixedFilters]="[
                  {
                    field: 'paymentResponseMessageTypeId',
                    value:
                      paymentResponseMessageType.paymentResponseMessageTypeId,
                    condition: 'equals',
                    fieldType: 'number'
                  }
                ]"
                (tableLoaded)="setTotal()"
              />
            </ng-template>
          </p-tabPanel>
          <p-tabPanel
            header="Pagamentos
            {{
              totalPayments !== undefined
                ? '(' + (totalPayments | number: '1.0-0') + ')'
                : ''
            }}"
          >
            <ng-template pTemplate="content">
              <app-table
                #paymentsTable
                [cols]="paymentCols"
                [service]="paymentService"
                [findPage]="findPaymentPage"
                [addButton]="false"
                modelName="pagamentos"
                sortField="creditCardPaymentId"
                [dropdownFilters]="dropdownFilters"
                [fixedFilters]="[
                  {
                    field: 'paymentResponseMessageTypeId',
                    value:
                      paymentResponseMessageType.paymentResponseMessageTypeId,
                    condition: 'equals',
                    fieldType: 'number'
                  }
                ]"
                [sortOrder]="1"
                *ngIf="dropdownFilters"
                [multiSelectFilter]="true"
                (tableLoaded)="setTotal()"
              />
            </ng-template>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  </div>
</ng-container>
<p-toast></p-toast>
<p-confirmPopup></p-confirmPopup>
